import React from 'react';
import { CHAT_TOKENS } from './chatTokens';
import { formatDayLabel } from './chatUtils';

/**
 * DateDivider — pill rendered by ChatConversation before the first
 * message of every new calendar day. See spec §72-77.
 */
export default function DateDivider({ iso, testid }) {
  const label = formatDayLabel(iso);
  if (!label) return null;
  return (
    <div className="flex justify-center my-3" data-testid={testid || 'chat-date-divider'}>
      <span
        className="px-2.5 py-0.5 rounded-full text-[10.5px] font-semibold"
        style={{ background: CHAT_TOKENS.dividerBg, color: CHAT_TOKENS.dividerText, backdropFilter: 'blur(8px)' }}
      >
        {label}
      </span>
    </div>
  );
}
